import { ReminderType, ResourceNotification } from "../../../resourcesTypes"

export function getReminderTimeLabel(sendMinutesBeforeMeeting?: number, sendMinutesAfterMeeting?: number): string {
    if (!sendMinutesBeforeMeeting && !sendMinutesAfterMeeting) return "Immediately"
    if (sendMinutesBeforeMeeting != null) {
        if (sendMinutesBeforeMeeting % 1440 === 0) return `${sendMinutesBeforeMeeting / 1440} day(s) before`
        if (sendMinutesBeforeMeeting % 60 === 0) return `${sendMinutesBeforeMeeting / 60} hour(s) before`
        return `${sendMinutesBeforeMeeting} minutes before`
    }

    if (sendMinutesAfterMeeting != null) {
        if (sendMinutesAfterMeeting % 1440 === 0) return `${sendMinutesAfterMeeting / 1440} day(s) after`
        if (sendMinutesAfterMeeting % 60 === 0) return `${sendMinutesAfterMeeting / 60} hour(s) after`
        return `${sendMinutesAfterMeeting} minutes after`
    }

    return "-"
}

export type NotificationFormValues = Readonly<{
    type: ReminderType
    reminderTime: number
    message?: string
}>

const initialValues: NotificationFormValues = {
    type: ReminderType.MEETING_START,
    message: "",
    reminderTime: 5,
}

export const getFormInitialValue = (notification: ResourceNotification | null): NotificationFormValues => {
    if (!notification) return initialValues

    return {
        reminderTime: notification?.sendInMinutesAfterMeeting ?? -Number(notification.sendInMinutesBeforeMeeting) ?? 0,
        message: notification.message,
        type: notification.type,
    }
}
